<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_iv"></a>Also by<br/><strong>L. A. BANKS</strong></p>
<p class="para"> </p>
<p class="center-para">NOVELS</p>
<p class="linespace"> </p>
<p class="center-para"><em>Bad Blood<br/>The Darkness<br/>The Cursed<br/>The Wicked<br/>The Damned<br/>The Forsaken<br/>The Forbidden<br/>The Bitten<br/>The Hunted<br/>The Awakening<br/>Minion</em></p>
<p class="linespace"> </p>
<p class="center-para">ANTHOLOGIES</p>
<p class="linespace"> </p>
<p class="center-para"><em>Stroke of Midnight<br/>Love at First Bite<br/>My Big Fat Supernatural Wedding</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?a3077fe6